import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { TextField, Button } from '@material-ui/core';
import Toast from '../../Layout/components/Toast';

const Root = styled(Box)({
    width: '801px',
    backgroundColor: '#ffffff',
    padding: '24px',
    '& .pageTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .title': {
        color: '#212C31',
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: '19px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '15px 0',
    },
    '& .textField': {
        width: '46%',
        marginRight: '30px',
    },
    '& .workWapper': {
        fontSize: '14px',
        margin: '10px 0',
    },
    '& .iconTextField': {
        width: '46%',
        marginRight: '30px',
        display: 'inline-flex',
        '& .icon': {
            fontSize: '20px',
            marginRight: '10px',
        },
        '& .rateText': {
            width: '30%',
            marginRight: '10px',
        },
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
});

class PasswordInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: "",
            confirmNewPassword: "",
            isError: false,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            isError,
            helperText,

            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <div className="pageTitle">SETTINGS</div>
                <div className="line"></div>
                <div className="title">Change User’s Password</div>
                <div className="textWapper v">
                    <TextField
                        required
                        id="outlined-required2"
                        label="New password"
                        className="textField"
                        margin="dense"
                        variant="outlined"
                        onChange={e => this.handleChange(e, "newPassword")}
                        error={isError}
                        helperText={helperText}
                        type="password"
                    />
                    <TextField
                        required
                        id="outlined-required3"
                        label="Confirm new password"
                        className="textField"
                        margin="dense"
                        variant="outlined"
                        onChange={e => this.handleChange(e, "confirmNewPassword")}
                        error={isError}
                        helperText={helperText}
                        type="password"
                    />
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>cancel</Button>
                    <Button variant="contained" color="primary" onClick={this.handleCreate}>save</Button>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
    }
    handleCreate() {
        const { newPassword, confirmNewPassword } = this.state;
        if (newPassword === "" || confirmNewPassword === "") {
            this.showToast("Password can not be blank");
            return;
        }
        if (newPassword === confirmNewPassword) {
            this.props.handleChangePwd(newPassword);
        } else {
            this.passwordError();
        }
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //textfield输入
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
        this.clearError();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    passwordError() {
        this.setState(() => ({
            isError: true,
            helperText: "Repeated password input error"
        }));
    }
    clearError() {
        this.setState(() => ({
            isError: false,
            helperText: "",
        }));
    }
}

export default PasswordInfo;